import Midia from "./Midia";

export default Midia;
